/**
 * Копирование текста в буфер обмена.
 *
 * navigator.clipboard браузер даёт только в защищённом контексте — HTTPS
 * или localhost. Сайт по http://IP его не получает, и копирование там
 * всегда заканчивалось бы отказом. Для такого случая остаётся прежний
 * способ: выделить текст в скрытом поле и выполнить команду копирования —
 * браузер разрешает её в обработчике нажатия.
 */
export async function copyText(value: string): Promise<void> {
  if (window.isSecureContext && typeof navigator.clipboard?.writeText === "function") {
    await navigator.clipboard.writeText(value);
    return;
  }

  const previousFocus = document.activeElement;
  // Поле кладётся внутрь открытого диалога: ловушка фокуса диалога
  // вернула бы фокус к себе, и выделение пропало бы до копирования.
  const host = previousFocus?.closest("dialog, [role='dialog']") ?? document.body;
  const field = document.createElement("textarea");
  field.value = value;
  field.setAttribute("readonly", "");
  field.setAttribute("aria-hidden", "true");
  field.style.position = "fixed";
  field.style.top = "0";
  field.style.left = "0";
  field.style.opacity = "0";
  field.style.pointerEvents = "none";
  host.append(field);
  try {
    // select() не везде переводит фокус, а копируется выделение в фокусе.
    field.focus({ preventScroll: true });
    field.select();
    if (!document.execCommand("copy")) throw new Error("Браузер запретил копирование");
  } finally {
    field.remove();
    if (previousFocus instanceof HTMLElement) previousFocus.focus();
  }
}
